import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductListingPage/ProductListingPageWrapper.js";
const variants = import.meta.webpackContext("/components/ProductListingPage", { recursive: true, regExp: /\.\/__variants__\/plp\-kylie\-carousel\/v2\/ProductListingPageWrapper\.js/ });
export default pointCut({ joinPoint, variants });